import api from '@/api/api.js'
import { DataLoadState } from '@/utils/storeUtils.js'

import { HuntAreaStore } from './huntAreaStore'

export const HUNT_AREAS_SEARCH_STORE_NAMESPACE = 'huntAreasSearch'
export const SELECTED_HUNT_AREA_STORE_NAMESPACE = 'selectedHuntArea'

// Mutation names
const SET_SEARCH_STARTED = 'setSearchStarted'
const SET_SEARCH_FINISHED_SUCCESSFULLY = 'setSearchFinishedSuccessfully'
const SET_SEARCH_FAILED = 'setSearchFailed'
const RESET_SEARCH = 'resetSearch'

// Getter names
export const IS_SEARCHING = 'isSearching'
export const GET_SEARCH_RESULT = 'getSearchResult'
export const GET_SEARCH_ERROR = 'getSearchError'
export const HAS_EMPTY_SEARCH_RESULT = 'hasEmptySearchResult'

// Action names
export const SEARCH_HUNT_AREAS = 'searchHuntAreas'
export const INVALIDATE_SEARCH_RESULTS = 'invalidateSearchResult'

// Hunt areas store implementation
export const HuntAreasSearchStore = {
  namespaced: true,

  modules: {
    [SELECTED_HUNT_AREA_STORE_NAMESPACE]: HuntAreaStore
  },

  state: () => ({ // state must be a function to allow reuse of this store
    searchState: new DataLoadState()
  }),

  mutations: {
    [SET_SEARCH_STARTED] (state, { query }) {
      const dataLoadState = new DataLoadState(query)
      state.searchState = dataLoadState.stateForLoadStarted()
    },

    [SET_SEARCH_FINISHED_SUCCESSFULLY] (state, { query, huntAreas }) {
      if (query !== state.searchState.id) {
        // Search is stale, ignore
        return
      }

      state.searchState = state.searchState.stateForLoadFinished(huntAreas)
    },

    [SET_SEARCH_FAILED] (state, { query, error }) {
      if (query !== state.searchState.id) {
        // Search is stale, ignore
        return
      }

      state.searchState = state.searchState.stateForLoadFailed(error)
    },

    [RESET_SEARCH] (state) {
      state.searchState = new DataLoadState()
    }
  },

  getters: {
    [IS_SEARCHING]: state => {
      return state.searchState.status.loading
    },

    [GET_SEARCH_RESULT]: state => {
      return state.searchState.data
    },

    [GET_SEARCH_ERROR]: state => {
      return state.searchState.status.error
    },

    [HAS_EMPTY_SEARCH_RESULT]: state => {
      return state.searchState.status.success && state.searchState.data.length === 0
    }
  },

  actions: {
    [SEARCH_HUNT_AREAS]: async ({ commit, state }, { query }) => {
      if (!query || query === '') {
        return
      }

      if (query === state.searchState.id &&
        !state.searchState.status.error) {
        // Only possible to search again for the same query if previous search failed
        return
      }

      // Start search
      commit(SET_SEARCH_STARTED, { query })

      try {
        const response = await api.get(`admin/huntareas?query=${query}`)
        const searchResult = response.data
          .slice(0)

        commit(SET_SEARCH_FINISHED_SUCCESSFULLY, { query, huntAreas: searchResult })
      } catch (error) {
        commit(SET_SEARCH_FAILED, { query, error })
      }
    },

    [INVALIDATE_SEARCH_RESULTS]: ({ commit }) => {
      commit(RESET_SEARCH)
    }
  }
}
